import React, { ReactElement } from 'react';
import { RouteComponentProps, Route, Switch, Redirect } from 'react-router-dom';
import ReceiveException from './ReceiveException';
import { RouteLoadDurationProvider } from '@awsscm/argo-core/argo/utils/metrics/ArgoRouteLoadDurationContext';

/**
 * match.path from RouteComponentProps will have the current browser path
 */
export type ReceiveProps = RouteComponentProps;

/**
 * Component for Receive Page
 * @component
 * @param {ReceiveProps} props
 */
const Receive = ({ match }: ReceiveProps): ReactElement => {
  return (
    <RouteLoadDurationProvider>
      <Switch>
        <Route path={`${match.path}/exception`} component={ReceiveException} />
        <Route path={`${match.path}/`}>
          <Redirect exact to="/assets-inventory" />
        </Route>
      </Switch> 
    </RouteLoadDurationProvider>
  );
};

export default Receive;
